import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_Mask = _resolveComponent("Mask")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_el_popover, {
      ref: "pp",
      width: $props.width,
      "popper-style": $props.popperStyle,
      "popper-class": $options.popover_class,
      "popper-options": $props.popperOptions,
      placement: $props.placement,
      persistent: $props.persistent,
      visible: $options.visible,
      trigger: $options.c_trigger,
      "show-arrow": $options.c_show_arrow,
      disabled: $props.disabled,
      "show-after": $props.showAfter,
      teleported: $options.c_teleported,
      offset: $props.offset,
      "aria-hidden": "false",
      inert: "true",
      transition: $props.transition,
      title: $props.title,
      "trigger-keys": $props.triggerKeys,
      "z-index": $options.c_z_index,
      onHide: _cache[0] || (_cache[0] = $event => (_ctx.$emit('hide'))),
      onShow: _cache[1] || (_cache[1] = $event => (_ctx.$emit('show'))),
      onBeforeEnter: $options.beforeEnter,
      onAfterLeave: $options.afterLeave
    }, {
      reference: _withCtx((data) => [
        _renderSlot(_ctx.$slots, "reference", _normalizeProps(_guardReactiveProps(data)))
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", { hide: $options.hide })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["width", "popper-style", "popper-class", "popper-options", "placement", "persistent", "visible", "trigger", "show-arrow", "disabled", "show-after", "teleported", "offset", "transition", "title", "trigger-keys", "z-index", "onBeforeEnter", "onAfterLeave"]),
    ($props.mask)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: $props.maskTarget
        }, [
          _createVNode(_component_Mask, {
            show: $data.show_popover,
            blur: $props.maskBlur,
            "z-index": $props.zIndex,
            onClick: _withModifiers($options.onMaskClick, ["stop"])
          }, null, 8 /* PROPS */, ["show", "blur", "z-index", "onClick"])
        ], 8 /* PROPS */, ["to"]))
      : _createCommentVNode("v-if", true)
  ])), [
    [_directive_click_outside, $options.onClickOutside]
  ])
}